'use client';

import './styles/@theme';
import { useStore } from '@/store/store';
import { SingleJackpotCard } from '@/app/components/site-wide-jackpot/subcomponents/single-jackpot-card';
import { getText } from '@/utils/text/text';
import type { Page } from './types';
import { getDybModalCTAClickedProps } from '@/tracking/amplitude/events/general/jackpots';

type DYBPageIntroductionProps = {
    pageData: Page;
    setNextPage: () => void;
    onClose: () => void;
    logoUrl?: string;
};

export const DYBPageIntroduction = ({ pageData, setNextPage, onClose, logoUrl }: DYBPageIntroductionProps) => {
    const { updatedTiers, loading } = useStore((state) => state.siteWideJackpot);
    const { sendEvent } = useStore((state) => state.tracking);

    const handleStartTour = () => {
        sendEvent([
            {
                destination: 'amplitude',
                eventProps: getDybModalCTAClickedProps({ linkText: 'start_tour', pageName: 'interstitial' })
            }
        ]);
        setNextPage();
    };

    const handleOnClose = () => {
        sendEvent([
            {
                destination: 'amplitude',
                eventProps: getDybModalCTAClickedProps({ linkText: 'x_clicked', pageName: 'interstitial' })
            }
        ]);
        onClose();
    };

    // Image paths - these should be in public folder
    const xIconUrl = '/images/icon-close-white-thin.svg';

    return (
        <div className="dyb-interstitial-container">
            <div className="dyb-interstitial-upper-content">
                <button className="dyb-interstitial-x-button" onClick={handleOnClose} aria-label="Close modal">
                    <img src={xIconUrl} alt="" aria-hidden="true" />
                </button>
                {logoUrl && <img className="dyb-interstitial-swj-logo" src={logoUrl} alt="jackpots logo" />}
                <div className="dyb-interstitial-jackpots-container">
                    {updatedTiers?.map((jackpotTier) => (
                        <SingleJackpotCard key={jackpotTier?.tier_id} jackpotTier={jackpotTier} loading={loading} />
                    ))}
                </div>
                <div className="dyb-interstitial-info">
                    <div className="dyb-interstitial-new-tag">
                        <p className="dyb-interstitial-new-tag-text">
                            {getText({ text: 'components.siteWideJackpots.doubleYourBet.new' })}
                        </p>
                    </div>
                    <p className="dyb-interstitial-p-1">{pageData.TITLE}</p>
                    <p className="dyb-interstitial-p-2">{pageData.DESCRIPTION}</p>
                </div>
            </div>
            <div className="dyb-interstitial-lower-content">
                <button className="dyb-interstitial-start-button" onClick={handleStartTour}>
                    {getText({ text: 'components.siteWideJackpots.doubleYourBet.startTour' })}
                </button>
            </div>
        </div>
    );
};
